import { faEyeSlash } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, CardContent, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, List, ListItem, ListItemText, Switch, Typography } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import * as pubApi from "api/Knowledge";
import styles from "assets/jss/cardCreation.styles";
import classNames from "classnames";
import { AppMessageBox } from 'components/AppMessageBox';
import ButtonClose from "components/Buttons/ButtonClose";
import IconButtonClose from 'components/Buttons/IconButtonClose';
import { RequestIndicator, SpinnerIndicator } from 'components/CallServer';
import RequestErrorDialog from "components/CallServer/RequestErrorDialog";
import { RequestErrorReport } from 'components/CallServer/RequestErrorReport';
import { ConvertUploadToFileThumbnaildGetDto, UploadingStatus } from 'components/FileUpload/AttachSelection';
import IconCaretDown from 'components/Icons/IconCaretDown';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import MuiClickable from 'components/MuiExtras/MuiClickable';
import MuiLink from 'components/MuiExtras/MuiLink';
import MuiWell from "components/MuiExtras/MuiWell";
import MuiMuted from 'components/MuiExtras/Typography/MuiMuted';
import QuillTextFieldCounter from 'components/Quill/QuillTextFieldCounter';
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import MediaUtils from 'lib/MediaUtils';
import { PublicationEditPermissions, PublicationType, SystemRoles } from 'models/ApiEnums';
import { AsyncUploadModel, ContentMetadata, ContentMetadataGetDto, FileThumbnaildGetDto, GetQuestionDto, SavePublicationResult, SaveQuestionDto, SearchPublicationDto } from 'models/ApiModels';
import { AttachType, RequestLifeCycle } from 'models/AppModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from "react-i18next";
import Session from 'services/Session';
import HandleAttach, { searchLink } from 'views/Publication/Components/HandleAttach';
import TopicsAndMembersBox from 'views/Publication/Components/TopicsAndMembersBox';
import * as FeedHelpers from 'views/Timeline/Components/FeedHelpers';
import { getPublicationUrl } from "views/Timeline/Components/FeedHelpers";

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const MaxChars = 1500;
const TakeRecords = 10;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface CreateFromPublicationProps {
    publicationId: string;
    publicationType: PublicationType;
    title: string;
    thumbnailUrl: string;
    authorName: string;
}

interface IProps {
    publicationId?: string;
    requestAnswerFromUser?: string;
    createFromPublication?: CreateFromPublicationProps;
    onClose: (result: SavePublicationResult) => void;
}

interface IValidation {
    title?: boolean;
    topics?: boolean;
}

interface IState {
    record: Partial<GetQuestionDto>;
    validation: IValidation;

    expanded: boolean;
    selectedAttach?: AttachType;
    step: number;
    uploadingStatus: UploadingStatus;
    formCycle: RequestLifeCycle;
    lastError: any;

    suggestionCycle: RequestLifeCycle;
    suggestionLastError: any;
    suggestionOpened: boolean;
    suggestionsHasMore: boolean;
    suggestionItems: Array<SearchPublicationDto>;
}

interface IDispatchProps {
}

type Props = IProps & IDispatchProps & WithStyles<typeof styles> & WithTranslation & WithSnackbar;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class CreateQuestion extends React.Component<Props, IState> {
    private refTitle: HTMLTextAreaElement;
    private timerLastChange: number;
    private timerQuestionMark: NodeJS.Timeout;
    private timerSuggestion: NodeJS.Timeout;
    private lastTitleChange: number;

    constructor(props: Props) {
        super(props);
        this.state = {
            record: null,
            validation: {
                title: null,
                topics: null,
            },

            expanded: false,
            selectedAttach: null,
            step: -1,

            uploadingStatus: "none",
            formCycle: RequestLifeCycle.Loading,
            lastError: null,

            suggestionCycle: RequestLifeCycle.None,
            suggestionLastError: null,
            suggestionOpened: false,
            suggestionsHasMore: false,
            suggestionItems: [],
        };
    }

    ///
    private analyse(text: string) {
        const attach = this.state.record.metadata;

        searchLink(text)
            .then((metadata) => {
                if (metadata == null)
                    this.setState({
                        record: this.updateRecord({ metadata: null, attachs: null }),
                        selectedAttach: null
                    });
                else if ((attach && metadata && attach.url != metadata.url) || attach == null) {
                    this.setState({
                        selectedAttach: AttachType.Link,
                        record: this.updateRecord({ metadata, attachs: null })
                    });
                }
            });
    }

    ///
    private loadPrediction() {
        if (this.state.step != 2) return;

        const { title, contentBody, publicationId, topics } = this.state.record;
        if (publicationId != null || topics?.length > 0) return;

        this.setState({ formCycle: RequestLifeCycle.Loading },
            () => {
                pubApi.getTopicPredictions(title, contentBody)
                    .then((result) => {
                        if (result) {
                            this.setState({
                                formCycle: RequestLifeCycle.None,
                                record: this.updateRecord({ topics: result.topics, relativesTopics: result.relativesTopics, deletedRelativesTopics: [] }),
                                validation: { ...this.state.validation, topics: true }
                            }, () => result?.topics.length > 0 && this.props.snackbar.showMessage(this.props.t("Views.Publication.Common.Form.TopicSuggestionFound"), "info"));
                        }
                        else {
                            this.setState({
                                formCycle: RequestLifeCycle.None
                            });
                        }
                    })
                    .catch((error) => {
                        this.setState({
                            formCycle: RequestLifeCycle.None
                        });
                    });

            });
    }

    //#region LOAD / SAVE

    ///
    private updateTitleValue(v: string, updateCaret: boolean = false) {

        if (this.timerSuggestion) clearTimeout(this.timerSuggestion);

        // Atualiza título
        var validation = this.state.validation;
        validation.title = v.length > 0;
        this.setState({
            record: this.updateRecord({ title: v }),
            validation
        }, () => updateCaret && this.handleTitleCaret());

        // Manipula sugestões após parar de teclar por 1s.
        this.lastTitleChange = new Date().getTime();
        this.timerSuggestion = setTimeout(() => {
            if ((new Date().getTime() - this.lastTitleChange) > 990) {
                this.checkSuggestion();
            }
        }, 1000);
    }


    ///
    private updateRecord(data: Partial<GetQuestionDto>) {
        return { ...this.state.record, ...data };
    }

    ///
    private afterLoad(record: GetQuestionDto) {
        var selectedAttach = null;
        if (record.metadata != null && record.metadata.provider == "publication")
            selectedAttach = AttachType.Publication;
        else if (record.metadata != null)
            selectedAttach = AttachType.Link;
        else if (record.attachs.length > 0) {
            selectedAttach = MediaUtils.getAttachTypeFromMimeType(record.attachs[0].mainFile.mimeType);
        }

        this.setState({
            formCycle: RequestLifeCycle.None,
            step: record.editPermissions == PublicationEditPermissions.None ? 0 : 1,
            record,
            selectedAttach,
            expanded: record.contentBody != null,
            validation: {
                topics: true,
                title: true
            }
        });
    }

    ///
    private loadEmpty(props: CreateFromPublicationProps) {

        var metadata: ContentMetadataGetDto = props == null
            ? null
            : {
                provider: "publication",
                uId: props.publicationId,
                title: props.title,
                image: props.thumbnailUrl,
                tumbnailUrl: props.thumbnailUrl,
                authorName: props.authorName,
                url: getPublicationUrl(props.publicationId, props.publicationType)
            };

        var record: GetQuestionDto = {
            publicationId: null,
            contentBody: null,
            title: "?",
            topics: [],
            relativesTopics: [],
            deletedRelativesTopics: [],
            attachs: [],
            metadata: metadata,
            isAnonymous: false,
            editPermissions: PublicationEditPermissions.Full,
            owner: {
                id: Session.user.id,
                culture: Session.user.culture,
                name: Session.user.name,
                thumbnailUrl: Session.user.thumbnailUrl
            }
        };

        this.afterLoad(record);
    }

    ///
    private load(publicationId: string) {
        this.setState({ formCycle: RequestLifeCycle.Loading });

        pubApi.getQuestion(publicationId)
            .then((record) => {
                this.afterLoad(record);
            })
            .catch((error) => {
                this.setState({ lastError: error, formCycle: RequestLifeCycle.LoadFailed });
            });
    }

    ///
    private canSave(): boolean {
        const { validation } = this.state;
        return validation.title && validation.topics;
    }

    ///
    private save() {
        const { record } = this.state;

        const dto: SaveQuestionDto = {
            publicationId: record.publicationId,
            title: record.title,
            contentBody: record.contentBody,
            metadata: record.metadata,
            attachs: record.attachs
                ? record.attachs.map((v) => {
                    return { fileId: v.mainFile.fileId, thumbnailId: v.thumbnail == null ? null : v.thumbnail.fileId };
                })
                : null,
            topics: record.topics.filter(p => !p.fixed).map((v) => { return v.key; }),
            relativesTopics: record.relativesTopics?.map((v) => { return v.key; }),
            isAnonymous: record.isAnonymous,
            requestAnswerFromUser: this.props.requestAnswerFromUser || null
        };

        this.setState({ formCycle: RequestLifeCycle.Posting });

        pubApi.saveQuestion(dto)
            .then((result) => {
                this.props.onClose(result);
            })
            .catch((error) => {
                this.setState({ lastError: error, formCycle: RequestLifeCycle.PostFailed });
            });

    }

    //#endregion

    //#region HANDLERS

    ///
    private handleFileUploaded = (e: AsyncUploadModel) => {
        var data: FileThumbnaildGetDto = ConvertUploadToFileThumbnaildGetDto(e);
        var at = MediaUtils.getAttachTypeFromMimeType(data.mainFile.mimeType);

        if (at == AttachType.Image) {
            const files = this.state.record.attachs == null ? [] : this.state.record.attachs;
            files.push(data);
            this.setState({
                selectedAttach: AttachType.Image,
                record: this.updateRecord({ attachs: files, metadata: null })
            });
        }
        else if (at == AttachType.Video)
            this.setState({
                selectedAttach: AttachType.Video,
                record: this.updateRecord({ attachs: [data], metadata: null })
            });
        else
            this.setState({
                selectedAttach: AttachType.File,
                record: this.updateRecord({ attachs: [data], metadata: null })
            });
    };

    ///
    private handleUploadRemove = (e: FileThumbnaildGetDto | ContentMetadata) => {

        if ((e as FileThumbnaildGetDto).mainFile) {
            const attach = e as FileThumbnaildGetDto;
            if (attach.mainFile.mimeType.indexOf("image/") > -1) {
                const files = this.state.record.attachs == null ? [] : this.state.record.attachs.filter(p => p.mainFile.fileId != attach.mainFile.fileId);
                this.setState({
                    selectedAttach: files.length == 0 ? null : AttachType.Image,
                    record: this.updateRecord({ attachs: files.length == 0 ? null : files, metadata: null })
                });
                return;
            }
        }

        this.setState({
            selectedAttach: null,
            record: this.updateRecord({ attachs: null, metadata: null })
        });
    };

    ///
    private handleUploadingStatus = (status: UploadingStatus) => {
        this.setState({ uploadingStatus: status });
    };

    ///
    private handleMetadataReceive = (metadata: ContentMetadata) => {
        this.setState({
            selectedAttach: AttachType.Publication,
            record: this.updateRecord({ attachs: null, metadata })
        });
    };

    ///
    private handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
        e.preventDefault();

        let pasteText = e.clipboardData.getData("text");

        if (pasteText.length > 0) {
            // Remove caracters especiais
            pasteText = pasteText.replace(/[^0-9a-zA-Z\u00C0-\u00FF\s,\.]/gi, '').trim();
            if (pasteText.length > 0) {

                // Atualiza Título
                if (this.timerQuestionMark) clearTimeout(this.timerQuestionMark);
                if (this.timerSuggestion) clearTimeout(this.timerSuggestion);

                const cv = e.currentTarget.value;
                var newText = cv.endsWith("?") ? cv.substr(0, this.refTitle.value.length - 1) : cv;
                if (newText.length > 0) newText += " ";
                newText += pasteText + "?";

                this.updateTitleValue(newText);
            }
        }
    };

    ///
    private handleTitleKeyUp = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {

        if (this.timerQuestionMark) clearTimeout(this.timerQuestionMark);

        this.timerLastChange = new Date().getTime();

        this.timerQuestionMark = setTimeout(() => {
            if ((new Date().getTime() - this.timerLastChange) > 200) {
                //  Adiciona "?" no final do texto.
                if (this.refTitle.value.length > 0 && this.refTitle.value[this.refTitle.value.length - 1] != "?") {
                    this.updateTitleValue(this.refTitle.value + "?", true);
                }
            }
        }, 200);
    };

    ///
    private handleTitleCaret = () => {
        // Reposiciona CARET antes do "?" do final do texto.
        if (this.refTitle) {
            if (this.refTitle.selectionStart == this.refTitle.selectionEnd) { // Garante que não está selecionando um texto
                if (this.refTitle.value.length > 1 && this.refTitle.selectionEnd > this.refTitle.value.length - 1) {
                    this.refTitle.selectionStart = this.refTitle.selectionEnd = this.refTitle.value.length - 1;
                }
            }
        }
    };

    ///
    private handleTitleFocus = () => {
        if (this.state.suggestionItems?.length == 0) this.checkSuggestion();
    };

    ///
    private handleTitleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        var v = event.target.value;

        switch (event.target.name) {
            case "title":
                this.updateTitleValue(v);
                break;
        }
    };

    ///
    private handleEditorChange = (html: string, text: string) => {
        this.setState({
            record: this.updateRecord({ contentBody: html, contentText: text }),
        }, () => this.checkSuggestion());

        if (this.state.selectedAttach == null || this.state.selectedAttach == AttachType.Link) {
            this.analyse(text);
        }
    };

    ///
    private handleExpandClick = () => {
        this.setState({ expanded: !this.state.expanded });
    };

    ///
    private handleAnonymous = () => {
        this.setState({ record: this.updateRecord({ isAnonymous: !this.state.record.isAnonymous }) });
    };

    //#endregion

    //#region SUGGESTION

    ///
    private checkSuggestion() {

        const { suggestionCycle, record } = this.state;
        if (record.publicationId != null || suggestionCycle == RequestLifeCycle.Loading) {
            return;
        }

        const words = record.title.split(" ");
        if (record.contentText?.length > 0 || record.attachs?.length > 0 || record.metadata != null || words.length < 3) {
            this.setState({ suggestionItems: [] });
            return;
        }

        this.loadSuggestions(0);
    }

    ///
    private loadSuggestions(offset: number) {
        this.setState({ suggestionCycle: RequestLifeCycle.Loading });

        const excludeQuestions = this.state.record.publicationId ? [this.state.record.publicationId] : null;

        pubApi.searchQuestionSuggestions(Session.user.id, this.state.record.title, excludeQuestions, offset, TakeRecords + 1)
            .then((suggestions) => {


                suggestions.forEach((v) => {

                    const arr = v.title.split(/\s/);
                    const marked: Array<any> = [];
                    const words = this.state.record.title.toLowerCase().split(/[ ,\.\?!]/);

                    arr.forEach((a) => {
                        if (words.findIndex(p => p.startsWith(a.toLowerCase())) > -1)
                            marked.push(`<b>${a}</b>`);
                        else
                            marked.push(a);
                    });

                    v.title = marked.join(" ");
                });

                const hasMore = suggestions.length == TakeRecords + 1;
                const newData = suggestions.slice(0, TakeRecords);

                this.setState({
                    suggestionCycle: RequestLifeCycle.None,
                    suggestionOpened: newData.length > 0,
                    suggestionItems: newData,
                    suggestionsHasMore: hasMore
                });

            })
            .catch((error) => {
                this.setState({
                    suggestionCycle: RequestLifeCycle.None,
                    suggestionLastError: error,
                    suggestionItems: [],
                    suggestionsHasMore: false
                });
            });
    }

    ///
    private renderSuggestions() {
        const { suggestionItems, suggestionsHasMore, suggestionCycle } = this.state;
        return (
            <div className={this.props.classes.suggestionContainer}>

                <MuiWell>
                    <div style={{ borderBottom: "solid 1px #e5e5e5", marginBottom: 4 }} >
                        <Typography variant="button" component="p">
                            {this.props.t("Views.Publication.CreateQuestion.SuggestionTitle")}
                        </Typography>
                        <MuiMuted><small>{this.props.t("Views.Publication.CreateQuestion.SuggestionSubtitle")}</small></MuiMuted>
                    </div>
                    <div style={{ height: 160, maxHeight: 160, overflowY: "auto" }}>
                        <List disablePadding>

                            {
                                suggestionCycle == RequestLifeCycle.Loading
                                    ? <SpinnerIndicator />
                                    : suggestionItems.map((suggestion, index) => (
                                        <ListItem key={index} disableGutters>
                                            <ListItemText
                                                primary={
                                                    (
                                                        <Typography variant="body2">
                                                            <MuiLink href={FeedHelpers.getPublicationUrl(suggestion.publicationId, suggestion.publicationType)} target="_blank">
                                                                <span dangerouslySetInnerHTML={{ __html: suggestion.title }} />
                                                            </MuiLink>
                                                        </Typography>
                                                    )
                                                }
                                            />
                                        </ListItem>
                                    ))
                            }

                            {
                                suggestionsHasMore &&
                                <ListItem onClick={() => this.loadSuggestions(suggestionItems.length)} >
                                    <ListItemText primary={this.props.t("Common.Filter.LoadMore")} />
                                </ListItem>
                            }
                        </List>

                    </div>
                </MuiWell>
            </div>
        );
    }

    //#endregion

    //#region STEPS

    ///
    private goStep1() {
        this.setState({ step: 1 });
    }

    ///
    private goStep2() {
        const { record, validation } = this.state;
        const v: IValidation = { title: true };
        let step = this.state.step;

        if (record.title == null || record.title.length == 0) {
            v.title = false;
        }

        if (v.title) step++;

        this.setState({
            step: step,
            validation: { ...validation, ...v }
        }, () => this.loadPrediction());
    }

    ///
    private canGoStep2(): boolean {
        return this.state.validation.title && this.state.uploadingStatus != "uploading";
    }

    ///
    private step1() {
        const { classes } = this.props;
        const { record, selectedAttach, validation, suggestionCycle, suggestionLastError, suggestionItems } = this.state;
        const { editPermissions } = record;

        const thumbTitle = this.props.t("Views.Publication.CreateQuestion.ThumbTitle");

        const thumbnail = (
            <MuiClickable onClick={this.handleAnonymous}>
                {
                    record.isAnonymous
                        ? <Avatar className={this.props.classes.avatarLarge} title={thumbTitle}><FontAwesomeIcon icon={faEyeSlash} size="2x" /></Avatar>
                        : <Avatar className={this.props.classes.avatarLarge} src={record.owner.thumbnailUrl} title={thumbTitle} />
                }
            </MuiClickable>
        );

        const acceptFileTypes = [AttachType.File, AttachType.Image, AttachType.Link];
        if (Session.hasRole(SystemRoles.PublisherVideo)) acceptFileTypes.push(AttachType.Video);

        return (
            <>
                <DialogContent className={classes.dialogContent}>

                    <div className={classes.container}>

                        <div className={classes.containerData} >

                            <Grid container spacing={3} alignContent="center" >
                                <Grid item>
                                    {thumbnail}
                                </Grid>
                                <Grid item style={{ flexGrow: 1 }}>
                                    <div
                                        className={classNames(
                                            classes.containerData_textarea,
                                            { ["" + classes.fieldError]: validation.title === false })
                                        }
                                    >

                                        <textarea
                                            autoFocus
                                            name="title"
                                            placeholder={this.props.t("Views.Publication.CreateQuestion.TitlePlaceholder")}
                                            autoComplete="off"
                                            maxLength={240}
                                            value={record.title}
                                            rows={3}
                                            tabIndex={0}
                                            ref={(ref) => { this.refTitle = ref; }}
                                            style={{ fontSize: "1.8em" }}
                                            readOnly={editPermissions != PublicationEditPermissions.Full}
                                            onChange={this.handleTitleChange}
                                            onFocus={this.handleTitleFocus}
                                            onKeyUp={this.handleTitleKeyUp}
                                            onPaste={this.handlePaste}
                                        />

                                    </div>

                                    {
                                        !this.state.expanded && editPermissions == PublicationEditPermissions.Full &&
                                        <MuiLink
                                            color="secondary"
                                            tabIndex={0}
                                            onClick={this.handleExpandClick}
                                        >
                                            <IconCaretDown />&nbsp;<span>{this.props.t("Views.Publication.CreateQuestion.TitleExpandText")}</span>
                                        </MuiLink>
                                    }

                                </Grid>
                            </Grid>

                            <Collapse in={this.state.expanded} timeout="auto">

                                <CardContent>
                                    <div className={classes.containerData_textarea}>
                                        <QuillTextFieldCounter
                                            onChange={this.handleEditorChange}
                                            htmlContent={record.contentBody}
                                            textContent={record.contentText}
                                            height={150}
                                            maxLength={MaxChars}
                                            theme={null}
                                            placeholder={this.props.t("Views.Publication.CreateQuestion.EditorPlaceholder")}
                                        />
                                    </div>

                                    <HandleAttach
                                        publicationId={record.publicationId}
                                        acceptedTypes={acceptFileTypes}
                                        selectedType={selectedAttach}
                                        attach={record.metadata || record.attachs}
                                        maxAttachFiles={1}
                                        readOnly={editPermissions != PublicationEditPermissions.Full}
                                        onUploadComplete={this.handleFileUploaded}
                                        onUploadRemove={this.handleUploadRemove}
                                        onUploadStatusChange={this.handleUploadingStatus}
                                        onMetadataReceived={this.handleMetadataReceive}
                                    />

                                </CardContent>
                            </Collapse>

                            {
                                suggestionItems.length > 0 &&
                                <div>
                                    {
                                        suggestionLastError
                                            ? <RequestErrorReport
                                                error={suggestionLastError}
                                                action={<ButtonClose onClick={() => this.setState({ suggestionLastError: null, suggestionCycle: RequestLifeCycle.None })} />}
                                            />
                                            : this.renderSuggestions()
                                    }
                                </div>
                            }
                        </div>
                    </div>


                </DialogContent>
                <DialogActions>

                    <div className={classes.footerMessage}>
                        <b>{this.props.t("Views.Publication.CreateQuestion.Footer1")}</b>
                        <span>&nbsp;&raquo;&nbsp;</span>
                        <span>{this.props.t("Views.Publication.Common.Form.Footer2")}</span>
                    </div>
                    <MuiRegularButton
                        variant="contained"
                        color="primary"
                        disabled={!this.canGoStep2()}
                        onClick={() => this.goStep2()}
                    >
                        <span>{this.props.t("Views.Publication.Common.Form.ButtonContinueText")}</span>
                    </MuiRegularButton>
                </DialogActions>
            </>
        );
    }

    ///
    private step2() {
        const { classes } = this.props;
        const { record } = this.state;
        return (
            <>
                <DialogContent>
                    <div className={classes.container}>

                        <TopicsAndMembersBox
                            skipTopicAccessFor={SystemRoles.PublicationManager}
                            topics={record.topics}
                            relativesTopics={record.relativesTopics}
                            deletedRelativesTopics={record.deletedRelativesTopics}
                            findRelativesTopics={record.publicationId == null}
                            onChange={
                                (topics, relativesTopics, deletedRelativesTopics) => {
                                    this.setState({
                                        record: this.updateRecord({ topics, relativesTopics, deletedRelativesTopics }),
                                        validation: { ...this.state.validation, ...{ topics: topics.length > 0 } }
                                    });
                                }
                            }
                        />

                        <FormGroup row>
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="isAnonymous"
                                        checked={record.isAnonymous}
                                        onChange={
                                            (e) => {
                                                this.setState({
                                                    record: this.updateRecord({ isAnonymous: (e.target as HTMLInputElement).checked })
                                                });
                                            }}
                                        value="isAnonymous"
                                        color="secondary"
                                    />
                                }
                                label={this.props.t<string>("Views.Publication.CreateQuestion.AnoynymousLabel")}
                            />
                        </FormGroup>


                    </div>

                </DialogContent>

                <DialogActions>
                    <div className={classes.actions}>

                        <MuiRegularButton variant="contained" onClick={() => this.goStep1()} >
                            <span>{this.props.t("Views.Publication.Common.Form.ButtonBackText")}</span>
                        </MuiRegularButton>

                        <MuiRegularButton
                            variant="contained"
                            color="success"
                            style={{ float: "right" }}
                            onClick={() => this.save()}
                            disabled={!this.canSave()}
                        >
                            <span>{this.props.t("Views.Publication.Common.Form.ButtonFinishText")}</span>
                        </MuiRegularButton>
                    </div>
                </DialogActions>
            </>
        );
    }

    //#endregion


    //#region PUBLIC

    ///
    public componentDidMount() {
        if (this.props.publicationId == null)
            this.loadEmpty(this.props.createFromPublication);
        else
            this.load(this.props.publicationId);
    }

    ///
    public render() {
        const { formCycle, lastError, step } = this.state;
        return (
            <Dialog
                open={true}
                maxWidth={"md"}
                fullWidth
            >
                <DialogTitle>
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6">
                                {this.props.t(this.state.record?.publicationId ? "Views.Publication.CreateQuestion.TitleEdit" : "Views.Publication.CreateQuestion.TitleNew")}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <IconButtonClose
                                color="inherit"
                                size="small"
                                onClick={() => this.props.onClose(null)}
                            />
                        </Grid>
                    </Grid>
                </DialogTitle>

                {
                    formCycle == RequestLifeCycle.LoadFailed
                        ? (
                            <>
                                <DialogContent className={this.props.classes.dialogContent}>
                                    <RequestErrorReport error={lastError} />;
                                </DialogContent>
                                <DialogActions />
                            </>
                        )
                        : step == 0
                            ? (
                                <>
                                    <DialogContent className={this.props.classes.dialogContent}>
                                        <AppMessageBox resource="PublicationEditPermissionDenied" />
                                    </DialogContent>
                                    <DialogActions />
                                </>
                            )
                            : step == 1
                                ? this.step1()
                                : step == 2
                                    ? this.step2()
                                    : null
                }

                <RequestIndicator type="request" open={formCycle == RequestLifeCycle.Loading} />
                <RequestIndicator type="post" open={formCycle == RequestLifeCycle.Posting} />

                <RequestErrorDialog
                    open={formCycle == RequestLifeCycle.PostFailed}
                    error={lastError}
                    onClose={() => this.setState({ lastError: null, formCycle: RequestLifeCycle.None })}
                />

            </Dialog>
        );
    }

    //#endregion
}

export default withSnackbar(withTranslation()(withStyles(styles)(CreateQuestion)));